module.exports = __webpack_public_path__ + "img/crab.f4f77fc9.png";